import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toogleVerify } from '../../../Utils/verifyblogSlice';
import HTMLReactParser from "html-react-parser";
import { toogleReload } from '../../../Utils/reloadSlice';

const VerifyBlog = ({formValue, setFormValue}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const postData = async () => {
        setLoading(true);
        const image = formValue.image.split("/")[8];
        try {
            await fetch('https://api.mokx.org/api/v1/blogs', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "category": formValue.category,
                  "name": formValue.heading,
                  "summary": formValue.content,
                  "audio": formValue.audio,
                  "images": image
                }),
            });
            setLoading(false);
            dispatch(toogleReload());
        } catch (error) {
          console.error("Error posting data:", error);
        }
        dispatch(toogleVerify());
    }

    const toggleVerifyHandler = () => {
        dispatch(toogleVerify());
        setFormValue({});
        setLoading(false);
    }

    const content = formValue.content;
    
    return (
        <>
            <div tabIndex="-1" className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                <div className="relative w-full max-w-lg max-h-full mx-auto">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <div className='flex items-center justify-between px-6 py-4'>
                            <h1 className='text-[#231F20] text-xl leading-8 font-figtree font-semibold'>Verify Blog</h1>
                            <button type="button" className="text-[#999CA0]" onClick={() => toggleVerifyHandler()}>
                            <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                        </button>
                        </div>
                        <div className='w-full h-[1px] bg-[#F2F2F2]'></div>
                        <div className='p-5 flex flex-col gap-6'>
                            <>
                                {formValue.image && (
                                    <img src={formValue.image} alt="Blog" style={{ maxWidth: '100%' }} />
                                )}
                            </>
                            <>
                                {formValue.audio && (
                                    <audio autoPlay controls src={formValue.audio} ></audio>
                                )}
                            </>
                            <div className='text-[#000] text-2xl font-figtree font-semibold'>{formValue.heading}</div>
                            <div className='text-justify'>{HTMLReactParser(content)}</div>
                        </div>
                        <div className='w-full h-[0.5px] bg-[#F2F2F2]'></div>
                        <div className='text-center p-5'>
                            <button onClick={() => postData()} disabled={loading} className='w-[18%] bg-[#3E84F8] disabled:opacity-50 rounded-[8px] px-4 py-2 text-[#FFF] text-sm font-figtree font-semibold'>
                                {!loading ? 'Post' : 'Posting'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full h-full bg-[#282c3f]/[0.5] fixed top-0 left-0 z-[49]' onClick={() => toggleVerifyHandler()}></div>
        </>
    )
}

export default VerifyBlog;